import React from "react";
import "../../assets/styles/components/model.scss";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

interface Props {
  show: boolean;
  onClose?: () => void;
  children?: object;
  width?: string;
  btnClose?: boolean;
  setStyle? : any; 
}
const EmptyModel: React.FC<Props> = ({
  show,
  onClose,
  children,
  width,
  btnClose = true,
  setStyle
}) => {
  return (
    <div className={`${show ? "modal-open" : "modal-close"}`}>
      <div
        className="custom"
        style={{ width: width, overflow: "auto", height: "100%", ...setStyle }}
      >
        {btnClose && (
          <div className="btn-close" onClick={onClose}>
            <Icon path={mdiClose} size="30" />
          </div>
        )}
        <div style={{ padding: "30px 40px" }}>{children}</div>
      </div>
    </div>
  );
};
export default EmptyModel;
